import {lazy, useMemo} from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const EventReview = lazy(() =>
  import('~/common/fabric/routes/EventReview/EventReview').then((module) => ({
    default: module.EventReview,
  }))
);

const stripeOptions = {
  fonts: [
    {
      src: 'url(https://fonts.evitecdn.com/pb/Brut_Grotesque_WEB-Book.woff2)',
      family: 'Brut',
      weight: '400',
    },
  ],
};

export const EventReviewWrapper = ({
  useCurrentRoute,
  navigateToRoute,
  saveFn,
  eventRepr,
  PreviewElementOverride,
  isProcessing = false,
}) => {
  const stripePromise = useMemo(() => loadStripe(window.stripePublishableKey), []);
  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <EventReview
        useCurrentRoute={useCurrentRoute}
        navigateToRoute={navigateToRoute}
        saveFn={saveFn}
        eventRepr={eventRepr}
        PreviewElementOverride={PreviewElementOverride}
        isProcessing={isProcessing}
      />
    </Elements>
  );
};
